import {
  ADD_BOOK_FAIL,
  ADD_BOOK_REQUEST,
  ADD_BOOK_RESET,
  ADD_BOOK_SUCCESS,
  BOOK_ORDER_FAIL,
  BOOK_ORDER_REQUEST,
  BOOK_ORDER_SUCCESS,
  FETCH_BOOK_FAIL,
  FETCH_BOOK_REQUEST,
  FETCH_BOOK_SUCCESS,
  FETCH_ORDERS_FAIL,
  FETCH_ORDERS_REQUEST,
  FETCH_ORDERS_RESET,
  FETCH_ORDERS_SUCCESS,
  FETCH_PREORDER_BOOKS_FAIL,
  FETCH_PREORDER_BOOKS_REQUEST,
  FETCH_PREORDER_BOOKS_SUCCESS,
  RESET_BOOK,
  RESET_BOOK_ORDER,
  UPDATE_BOOK_FAIL,
  UPDATE_BOOK_SUCCESS,
} from "../constants";

export const preOrderBooksReducer = (state = { preOrderBooks: [] }, action) => {
  switch (action.type) {
    case FETCH_PREORDER_BOOKS_REQUEST:
      return { ...state, loading: true };
    case FETCH_PREORDER_BOOKS_SUCCESS:
      return { preOrderBooks: action.payload, loading: false };
    case FETCH_PREORDER_BOOKS_FAIL:
      return { error: action.payload };
    default:
      return state;
  }
};
export const fetchBookReducer = (
  state = { currentItem: {}, currentBook: {}, error: null, loading: false },
  action
) => {
  switch (action.type) {
    case FETCH_BOOK_REQUEST:
      return { ...state, loading: true };
    case FETCH_BOOK_SUCCESS:
      return {
        currentItem: action.payload,
        currentBook: action.payload,
        loading: false,
      };
    case UPDATE_BOOK_SUCCESS:
      return {
        currentItem: action.payload,
        currentBook: action.payload,
        loading: false,
      };
    case UPDATE_BOOK_FAIL:
      return { error: action.payload };
    case FETCH_BOOK_FAIL:
      return { error: action.payload };
    case RESET_BOOK:
      return { currentItem: null, currentBook: null };
    default:
      return state;
  }
};

export const bookOrderReducer = (
  state = { order: {}, success: false },
  action
) => {
  switch (action.type) {
    case BOOK_ORDER_REQUEST:
      return { ...state, loading: true };
    case BOOK_ORDER_SUCCESS:
      return { order: action.payload, success: true, loading: false };
    case BOOK_ORDER_FAIL:
      return { error: action.payload, success: false };
    case RESET_BOOK_ORDER:
      return { order: {}, success: false, loading: false };
    default:
      return state;
  }
};

export const fetchBookOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_ORDERS_REQUEST:
      return { ...state, loading: true };
    case FETCH_ORDERS_SUCCESS:
      return { orders: action.payload, loading: false };
    case FETCH_ORDERS_FAIL:
      return { error: action.payload, loading: false };
    case FETCH_ORDERS_RESET:
      return {};
    default:
      return state;
  }
};

export const addBookReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_BOOK_REQUEST:
      return { loading: true };
    case ADD_BOOK_SUCCESS:
      return { success: true, loading: false };
    case ADD_BOOK_FAIL:
      return { error: action.payload, loading: false };
    case ADD_BOOK_RESET:
      return {};

    default:
      return state;
  }
};
